import React from "react";
import PropTypes from "prop-types";
import { Label, Form } from "semantic-ui-react";

const CustomInput = ({ title, type, error, onChange }) => {
  return (
    <Form.Field className="custom-input">
      <Form.Input
        label={title}
        fluid
        error={!!error}
        type={type}
        onChange={onChange}
      />
      {error ? (
        <Label basic color="red" pointing>
          Please enter a value
        </Label>
      ) : null}
    </Form.Field>
  );
};

CustomInput.propTypes = {
  title: PropTypes.string,
  error: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
};

export default CustomInput;
